var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    height: "1em",
    width: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.666,129.254h-45.223l69.263-69.263c6.637-6.637,10.293-15.462,10.293-24.849c0-9.387-3.655-18.212-10.293-24.849 C495.068,3.656,486.245,0,476.857,0s-18.212,3.655-24.849,10.293L333.047,129.255H210.262 c-0.52-25.381-21.314-45.871-46.817-45.871H46.842c-9.057,0-16.425-7.368-16.425-16.424c0-9.057,7.368-16.425,16.425-16.425 h237.505c25.829,0,46.842-21.013,46.842-46.842h-30.417c0,9.057-7.368,16.425-16.425,16.425H46.842 C21.013,20.116,0,41.129,0,66.958C0,92.787,21.013,113.8,46.842,113.8h116.601c8.729,0,15.869,6.85,16.376,15.454H34.333 C15.401,129.254,0,144.656,0,163.588v314.078c0,18.932,15.401,34.333,34.333,34.333h443.333c18.932,0,34.333-15.401,34.333-34.333 V163.588C512,144.656,496.598,129.254,477.666,129.254z M376.064,129.256l97.453-97.455c1.842-1.841,4.839-1.841,6.683,0 c1.842,1.842,1.842,4.839,0,6.683l-90.771,90.771l-50.695,50.695l-92.401,92.401l-6.739,0.058l0.058-6.739L376.064,129.256z  M233.974,302.874l25.064-0.215l92.293-92.293h79.555v220.52H81.112v-220.52h170.822l-42.594,42.595l-0.43,50.127L233.974,302.874 z M481.583,477.666c0,2.16-1.757,3.916-3.916,3.916H34.333c-2.159,0-3.916-1.756-3.916-3.916V163.588 c0-2.16,1.757-3.916,3.916-3.916H302.63l-20.278,20.278H50.695v281.355h410.609V179.949H381.75l20.278-20.278h75.639 c2.159,0,3.916,1.756,3.916,3.916V477.666z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt);
export default __webpack_public_path__ + "static/media/art.767bc36d.svg";
export { ForwardRef as ReactComponent };